import { useEffect, useState } from 'react';
import { H5 } from 'UIComponents/elements/headings';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UISection from 'UIComponents/section/UISection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EventSegmentationFilters from 'automation-ui-enrollment/components/eventEnrollment/steps/EventSegmentationFilters';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import { isFilterEmpty } from 'automation-ui-flow-core/enrollment/enrollmentUtils';
import useHasWebhookTriggersAccess from 'automation-ui-enrollment/hooks/useHasWebhookTriggersAccess';
import TriggersAIAssistantButton from 'automation-ui-enrollment/components/eventEnrollment/TriggersAIAssistantButton';
import styled from 'styled-components';
import { GREAT_WHITE, GYPSUM } from 'HubStyleTokens/colors';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledCriteraBorder = styled.div.withConfig({
  displayName: "EventEnrollmentReview__StyledCriteraBorder",
  componentId: "sc-19nxhq3-0"
})(["border:1px solid ", ";background:", ";border-radius:4px;padding:", ";"], ({
  borderColor
}) => borderColor || GREAT_WHITE, ({
  background
}) => background || GYPSUM, ({
  padding
}) => padding ? `${padding}px` : '16px');
const EventEnrollmentReview = ({
  bannerComponents,
  objectTypeId,
  readOnly,
  stagedChanges,
  setStagedChanges,
  setAreFiltersIncomplete,
  setPanelStep
}) => {
  const shouldEventPanelDefaultOpen = !readOnly && !stagedChanges.refinementCriteria && isFilterEmpty(stagedChanges.triggers);
  const [panelUsedBy, setPanelUsedBy] = useState(shouldEventPanelDefaultOpen ? 'TRIGGERS' : undefined);

  /* we set readOnly to true when we render the ListMembershipErrorBanner because SegmentationFilters doesn't update
  the value in their UI while it's in edit mode. We can remove this if that bug is resolved or we can remove the banner */
  useEffect(() => {
    if (readOnly) {
      setPanelUsedBy(undefined);
    }
  }, [readOnly, setPanelUsedBy]);
  const {
    hasWebhookTriggersScope,
    webhookTriggersAllowedForObjectType
  } = useHasWebhookTriggersAccess(objectTypeId);
  const canEditRefinementCriteria = !!stagedChanges.triggers && !!stagedChanges.triggers.filterBranches.length;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UISection, {
      className: "m-bottom-5",
      children: [/*#__PURE__*/_jsx(EventSegmentationFilters, {
        WrapperComponent: StyledCriteraBorder,
        headerNode: readOnly ? /*#__PURE__*/_jsx(H5, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.events.cardHeader"
          })
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(H5, {
            className: "display-inline m-right-1",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation-ui-enrollment.redesign.review.startThisWorkflow"
            })
          }), /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation-ui-enrollment.redesign.review.optional"
            })
          })]
        }),
        subheaderNode: /*#__PURE__*/_jsxs(View, {
          marginBlockEnd: "400",
          as: "div",
          children: [/*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "automation-ui-enrollment.redesign.review.learnMoreAboutTriggers_jsx",
              elements: {
                Link: UILink
              },
              options: {
                external: true,
                href: 'https://knowledge.hubspot.com/workflows/set-event-enrollment-triggers'
              }
            })
          }), !readOnly && /*#__PURE__*/_jsx(TriggersAIAssistantButton, {
            marginBlockStart: "200"
          })]
        }),
        objectTypeId: objectTypeId,
        onStartEditingFilters: () => {
          setPanelUsedBy('TRIGGERS');
        },
        onDoneEditingFilters: () => {
          setPanelUsedBy(undefined);
        },
        isEditButtonDisabled: panelUsedBy === 'REFINEMENT_CRITERIA',
        editButtonDisabledTooltipMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.disabledTooltip.triggers"
        }),
        readOnly: readOnly,
        value: stagedChanges.triggers,
        onChange: triggers => {
          setStagedChanges(Object.assign({}, stagedChanges, {
            triggers
          }));
        },
        onAreFiltersIncompleteChange: setAreFiltersIncomplete,
        bannerComponents: bannerComponents,
        openInEditMode: shouldEventPanelDefaultOpen,
        strategyOptions: {
          showListMembershipFilterFamily: true
        }
      }), hasWebhookTriggersScope && webhookTriggersAllowedForObjectType && !panelUsedBy && !readOnly && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "300",
        as: "div",
        children: /*#__PURE__*/_jsxs(UILink, {
          onClick: () => setPanelStep('WEBHOOK_SELECTION'),
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "filter"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.review.manageWebhookTriggers"
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(UISection, {
      className: "m-bottom-5",
      children: /*#__PURE__*/_jsx(ListSegmentationFilters, {
        WrapperComponent: StyledCriteraBorder,
        headerNode: /*#__PURE__*/_jsxs(View, {
          marginBlock: "300",
          as: "div",
          children: [/*#__PURE__*/_jsx(H5, {
            className: "m-bottom-0",
            children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              objectTypeId: objectTypeId,
              baseLangKey: "automation-ui-enrollment.redesign.review.refinement.refineFilters_cob"
            })
          }), /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              objectTypeId: objectTypeId,
              baseLangKey: "automation-ui-enrollment.redesign.review.refinement.refineFiltersDescription_cob"
            })
          })]
        }),
        value: stagedChanges.refinementCriteria,
        onStartEditingFilters: () => {
          setPanelUsedBy('REFINEMENT_CRITERIA');
        },
        onDoneEditingFilters: () => {
          setPanelUsedBy(undefined);
        },
        isEditButtonDisabled: panelUsedBy === 'TRIGGERS' || !canEditRefinementCriteria,
        editButtonDisabledTooltipMessage: canEditRefinementCriteria ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.disabledTooltip.refinementCriteria"
        }) : undefined,
        showDoneButton: true,
        readOnly: readOnly,
        objectTypeId: objectTypeId,
        onChange: refinementCriteria => setStagedChanges(Object.assign({}, stagedChanges, {
          refinementCriteria
        })),
        onFilterInfoChange: ({
          hasIncompleteFilters,
          hasFilterValidationErrors
        }) => setAreFiltersIncomplete(Boolean(hasIncompleteFilters || hasFilterValidationErrors))
      })
    })]
  });
};
export default EventEnrollmentReview;